import {Directive, ElementRef, EventEmitter, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {AppConfigService} from "@service/config/app-config.service";
import {CountryList} from "@service/enum/process-state.enum";
import {NgControl} from "@angular/forms";

declare var google: any;

@Directive({
    selector: '[google-place]'
})
export class GooglePlacesDirective implements OnInit, OnChanges {
    @Output() onSelect: EventEmitter<any> = new EventEmitter();
    autocomplete: any;
    private element: HTMLInputElement;
    private options: any;
    private appConfig: any = AppConfigService.config;

    constructor(private elRef: ElementRef, private eleControl: NgControl) {
        /* elRef will get a reference to the element where the directive is placed */
        this.element = elRef.nativeElement;
        this.options = {
            componentRestrictions: {country: this.appConfig.supportedCountries || ['US']}
        };
    }

    getFormattedAddress(place) {
        /*  @params: place - Google Autocomplete place object
            @returns: location_obj - An address object in human readable format */
        const location_obj: {} = {};
        place.address_components.forEach(function (element) {
            const item = element;
            location_obj['formatted_address'] = place.formatted_address;
            if (item['types'].indexOf('locality') > -1 || (!location_obj['locality'] && item['types'].indexOf('neighborhood') > -1) ||
                (!location_obj['locality'] && item['types'].indexOf('administrative_area_level_3') > -1)) {
                location_obj['locality'] = item['long_name'];
            } else if (item['types'].indexOf('administrative_area_level_1') > -1) {
                location_obj['admin_area_l1'] = item['short_name'];
            } else if (item['types'].indexOf('street_number') > -1) {
                location_obj['street_number'] = item['short_name'];
            } else if (item['types'].indexOf('route') > -1) {
                location_obj['route'] = item['long_name'];
            } else if (item['types'].indexOf('country') > -1) {
                location_obj['country3'] = CountryList.find(cn => cn.alpha2.toLowerCase() === item['short_name'].toLowerCase()).alpha3;
                location_obj['country'] = item['long_name'];
            } else if (item['types'].indexOf('postal_code') > -1) {
                location_obj['postal_code'] = item['short_name'];
            } else if (item['types'].indexOf('administrative_area_level_2') > -1) {
                location_obj['county'] = item['long_name'].replace(/\County$/i, '').trim();
            }
        });
        return location_obj;
    }

    ngOnInit() {
        if (!this.autocomplete) {
            setTimeout(() => {
                this.initGoogleAutocomplete();
            }, 700);
        }
    }

    initGoogleAutocomplete() {
        this.autocomplete = new google.maps.places.Autocomplete(this.element, this.options);

        if (this.autocomplete) {
            // Event listener to monitor place changes in the input
            google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
                const formattedAddress = this.getFormattedAddress(this.autocomplete.getPlace());
                // Emit the new address object for the updated place
                if (!formattedAddress['route'] ||
                    !formattedAddress['locality'] ||
                    !formattedAddress['country'] ||
                    !formattedAddress['admin_area_l1'] ||
                    !formattedAddress['postal_code'] ) {
                    this.eleControl.control.setErrors({'invalid': true});
                } else {
                    this.eleControl.control.setErrors(null);
                }
                this.onSelect.emit(formattedAddress);

            });
        }

    }


    firePlaceChangedEvent() {
        if (google) {
            this.autocomplete = new google.maps.places.Autocomplete(this.element, this.options);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log(changes);
    }

}
